(function () {
  var trigger = document.getElementById('InfiniteScrollTrigger');
  if (!trigger) return;

  var currentPage = parseInt(trigger.dataset.currentPage, 10);
  var totalPages = parseInt(trigger.dataset.totalPages, 10);
  var sectionId = trigger.dataset.sectionId;
  var collectionUrl = trigger.dataset.collectionUrl;
  var spinner = document.getElementById('InfiniteScrollSpinner');
  var loading = false;

  if (currentPage >= totalPages) {
    if (spinner) spinner.classList.add('hidden');
    return;
  }

  function loadNextPage() {
    if (loading || currentPage >= totalPages) return;
    loading = true;
    if (spinner) spinner.classList.remove('hidden');

    currentPage++;

    // Build URL preserving any existing query params (filters, sort)
    var params = new URLSearchParams(window.location.search);
    params.set('page', currentPage);
    params.set('section_id', sectionId);

    var url = collectionUrl + '?' + params.toString();

    fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newGrid = doc.getElementById('product-grid');

        if (!newGrid) {
          currentPage = totalPages; // stop trying
          if (spinner) spinner.classList.add('hidden');
          return;
        }

        var newItems = newGrid.querySelectorAll(':scope > li');
        var existingGrid = document.getElementById('product-grid');

        if (newItems.length === 0) {
          currentPage = totalPages;
        } else {
          newItems.forEach(function (item) {
            // Remove scroll animation delays for appended items
            item.classList.remove('scroll-trigger');
            item.classList.remove('animate--slide-in');
            item.style.removeProperty('--animation-order');
            existingGrid.appendChild(item);
          });
        }

        loading = false;

        if (currentPage >= totalPages) {
          if (spinner) spinner.classList.add('hidden');
          observer.unobserve(trigger);
        }
      })
      .catch(function () {
        loading = false;
        if (spinner) spinner.classList.add('hidden');
      });
  }

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadNextPage();
        }
      });
    },
    {
      rootMargin: '400px', // Start loading 400px before visible
    }
  );

  observer.observe(trigger);

  // Re-initialize after facets.js replaces the grid (filter/sort changes)
  var gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    var mutationObserver = new MutationObserver(function () {
      var newTrigger = document.getElementById('InfiniteScrollTrigger');
      if (newTrigger && newTrigger !== trigger) {
        // Facets replaced the grid — reset state
        trigger = newTrigger;
        currentPage = parseInt(trigger.dataset.currentPage, 10);
        totalPages = parseInt(trigger.dataset.totalPages, 10);
        spinner = document.getElementById('InfiniteScrollSpinner');
        loading = false;

        if (currentPage < totalPages) {
          observer.observe(trigger);
        }
      }
    });

    mutationObserver.observe(gridContainer, { childList: true, subtree: false });
  }
})();
